import { StyleSheet } from 'aphrodite';
import constants from '../../../../constants/styles';
let {
  STATUS_PARENT_LABEL_COLOR,
  STATUS_PARENT_VALUE_COLOR,
  STATUS_PARENT_BG_COLOR,
  STATUS_PARENT_HOVER_BG_COLOR,
  TABLE_BG_COLOR,
  STATUS_PARENT_VALUE_COLOR_HEADER
} = constants;

let styles = {
  bases: {
    minWidth: 820,
    display: 'flex',
    flex: 1,
    backgroundColor: STATUS_PARENT_BG_COLOR,
    padding: '20px 10px 25px 20px',
    borderRadius: 8,
    marginBottom: 10,
    textTransform: 'uppercase'
  },

  base: {
    flex: 1,
    display: 'flex',
    minWidth: 820,
    backgroundColor: STATUS_PARENT_BG_COLOR,
    padding: '20px 10px  25px 20px',
    borderRadius: 8,
    borderBottom: `1px solid ${TABLE_BG_COLOR}`,
    ':hover': {
      backgroundColor: STATUS_PARENT_HOVER_BG_COLOR
    }
  },
  heading: {
    fontSize: 16,
    textTransform: 'uppercase',
    fontWeight: 500
  },
  field: {
    alignSelf: 'center',
    fontSize: '1.1em',
    color: STATUS_PARENT_VALUE_COLOR,
    padding: 5,
    fontWeight: 'normal',
    textTransform: 'uppercase',
    verticalAlign: 'middle'
  },
  fieldsHeader: {
    color: STATUS_PARENT_VALUE_COLOR_HEADER,
    alignSelf:'center',
    flex: 'none',
    padding: 5,
    fontWeight: 800,
    fontSize: '15px'
  },
  nodeAddress: {
    minWidth: 200,
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  label: {
    fontSize: '0.7em',
    fontWeight: 800,
    textTransform: 'uppercase',
    color: STATUS_PARENT_LABEL_COLOR,
    marginBottom: 5,
    width: '100%',
    textAlign: 'center'
  },
  green: {
    height: 10,
    width: 10,
    backgroundColor: 'rgb(120, 224, 139)',
    borderRadius: '50%'
  },
  red: {
    height: 10,
    width: 10,
    backgroundColor: '#f75e5e',
    borderRadius: '50%'
  },
  yellow: {
    height: 10,
    width: 10,
    backgroundColor: 'rgb(247, 206, 94)',
    borderRadius: '50%'
  },
  light: {
    width: '13%'
  },
  apcountHeader: {
    width: 80
  },
  accessPointsCount: {
    flex: 'none',
    width: 80
  },
  status: {
    width: 60,
    display: 'flex',
    justifyContent: 'center'
  },
  trash: {
    width: 10, 
    flex: 'none',
    marginLeft: 45,
    cursor: 'pointer'
  },
  nodeAddressHeader: {
    flex: 1,
    minWidth: 200
  },
  gatewayNoDataRow: {
    width: '62.4%'
  },
  name: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  downtime: {
    width: 80
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/status/gateway/gatewayRow.styles.js